import React, { createContext, useContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [userId, setUserId] = useState(null);
    const [user, setUser] = useState(null); // ✅ ADD THIS
    const [loading, setLoading] = useState(true); // ✅ ADD THIS

    useEffect(() => {
        const auth = getAuth();

        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            if (firebaseUser) {
                setUserId(firebaseUser.uid);
                setUser(firebaseUser); // ✅ IMPORTANT
                localStorage.setItem("userId", firebaseUser.uid);
            } else {
                setUserId(null);
                setUser(null); // ✅ IMPORTANT
                localStorage.removeItem("userId");
            }

            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return (
        <AuthContext.Provider value={{ userId, user, loading }}>
            {children}
        </AuthContext.Provider>
    );
};